import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Electricity: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m360 504.76h-30v-84.76h-132.51c-7.27 0-13.67-4.39-16.3-11.18-2.64-6.81-.87-14.39 4.52-19.31l.1-.09 295.62-264.91c5.11-4.61 12.46-5.8 18.75-3.02 6.34 2.8 10.44 9.1 10.44 16.04v162.47h-30v-134.48l-250.5 224.48h129.88z' />
    <path d='m600 429.43c-11.36-12.06-30.35-12.63-42.41-1.27l-197.59 187.83v-128.99c0-8.28-6.72-15-15-15s-15 6.72-15 15v158c0 8.28 6.72 15 15 15 10 0 15-5 20-10z' />
  </IconBase>
));

Electricity.displayName = 'Electricity';

export default Electricity;
